export const types = {
  elective: 'Eletiva',
  surgery: 'Cirúrgica',
};

export function getName(key, defaultValue = '-') {
  return key in types ? types[key] : defaultValue;
}
